<template>
    <div class="card asset-card">
        <span
            v-if="enableToggleFavorite || currentTeam.is_favorite"
            title="Favorite Team"
            class="favorite-asset d-flex flex-row"
            :class="{ clickable: enableToggleFavorite }"
            @click="toggleFavorite"
        >
            <icon-star
                :active="currentTeam.is_favorite"
                height="20px"
                width="20px"
            ></icon-star>
        </span>
        <div class="image-container" ref="anchor">
            <a
                :href="'/advertiser/teams/' + currentTeam.id"
                class="cover-box asset-image"
                title="Team Image"
            >
                <img
                    v-if="currentTeam.photo_url"
                    :src="currentTeam.photo_url"
                    :alt="currentTeam.name + ' Image'"
                />
            </a>
        </div>
        <div class="card-body">
            <h5 class="card-title">
                <a
                    :href="'/advertiser/teams/' + currentTeam.id"
                    :title="currentTeam.name"
                >
                    {{ currentTeam.name }}
                </a>
            </h5>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        team: {
            required: true,
        },
        enableToggleFavorite: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        currentTeam: null,
        togglingFavorite: false
    }),
    watch: {
        team: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.currentTeam = newVal;
            },
        },
    },
    methods: {
        async toggleFavorite() {
            if (!this.enableToggleFavorite || this.togglingFavorite) {
                return;
            }

            try {
                this.togglingFavorite = true;

                const response = await axios.post(`/api/advertiser/teams/${this.currentTeam.id}/favorite`);

                // Update the local state
                this.currentTeam.is_favorite = response.data.data.is_favorite;

                // Emit event to parent component
                this.$emit('favorite-toggled', this.currentTeam.id, response.data.data.is_favorite);

                // Emit global event to update sidebar
                Bus.$emit('favoriteToggled', this.currentTeam.id, response.data.data.is_favorite);

            } catch (error) {
                console.error('Failed to toggle team favorite:', error);
                // You might want to show a toast or error message here
            } finally {
                this.togglingFavorite = false;
            }
        }
    }
};
</script>

<style scoped>
.favorite-asset.clickable {
    cursor: pointer;
}

.favorite-asset.clickable:hover {
    opacity: 0.8;
}
</style>